import { PaymentType } from '@/features/graphql/generated/graphql'

export const getPaymentType = (identifier: string): PaymentType | undefined =>
    Object.values(PaymentType).find((paymentType) => paymentType === identifier)
